import { useEffect } from 'react';

export const useDocumentTitle = (title: string | ((currentTitle: string) => string), dependency?: any): void => {
    let _title = "";
    if(typeof title === 'string'){
        _title = title;
    } else {
        _title = title(document.title)
    }
    useEffect(() => {
        document.title = _title;
    }, [dependency])
}